// ==========================
// src/components/Privacy.jsx
// ==========================
import React from 'react';
import { Typography, List, ListItem, ListItemText, Link, Box } from '@mui/material';

export default function Privacy(){
  return (
    <Box>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Este sitio web de <strong>Ángel de Oro</strong> es informativo. <strong>No</strong> recolectamos ni vendemos datos personales a través de formularios o cuentas en el sitio. Usamos únicamente <strong>cookies técnicas necesarias</strong> para el funcionamiento básico.
      </Typography>
      <List dense>
        <ListItem>
          <ListItemText
            primary="Cookies"
            secondary="Solo técnicas/esenciales. No usamos cookies de analítica ni de marketing."
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Contenidos de terceros"
            secondary="La previsualización de mapas usa un iframe de Google Maps que se carga solo si tú lo solicitas (al presionar ‘Previsualizar’). Google podría recibir tu IP y aplicar sus propias cookies/políticas."
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Contacto por WhatsApp"
            secondary={<>
              Al hacer clic en el enlace de WhatsApp, serás redirigido a dicha plataforma; aplican sus términos y políticas.
            </>}
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Seguridad"
            secondary="Usamos cifrado en tránsito (HTTPS) cuando está disponible para proteger la comunicación."
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Tus derechos"
            secondary={<>
              Si deseas más información o ejercer derechos de acceso, rectificación o eliminación, escríbenos a
              {' '}<Link href="mailto:info@angeldeoro.com">info@angeldeoro.com</Link>.
            </>}
          />
        </ListItem>
      </List>
      {/* <Typography variant="caption" color="text.secondary">
        *Este texto es informativo y no constituye asesoría legal. Ajusta según la normativa aplicable en tu jurisdicción.
      </Typography> */}
    </Box>
  );
}